// extracted by mini-css-extract-plugin
module.exports = {"container":"placeholder_container__1K7QM","icon":"placeholder_icon__1esNG","textColor":"placeholder_textColor__2IXAu"};